import React, { Component } from 'react';
import InputMask from 'react-input-mask';

class Input extends Component {


  render(){
    const {
      label,
      value,
      type,
      onChange,
      className,
      mask,
      stripe,
      editable = true
    } = this.props;
    var val = value;
    if(!val){
      val = "";
    }
    return (


      <div className="dm-input flex-item left-flex">

        <div style={{flex: 10}}>
          <div className={val.length && value !== null > 0 ? "floating-label active animated fadeInUp" : "floating-label animated fadeOutDown"}>
            <label>{label}</label>
          </div>
          <div>
            <InputMask
              readOnly={!editable}
              className={val.length > 0 ? "active "+className : className}
              type={type}
              onChange={onChange}
              value={value}
              placeholder={label}
              autoComplete="off"
              mask={mask}
              alwaysShowMask={false}
              maskChar=" "
              data-stripe={stripe}
            />
          </div>
        </div>

      </div>
    );
  }
}
export { Input };



// WEBPACK FOOTER //
// ./src/components/common/Input.js